export function isClient() {
  return typeof window !== 'undefined' || typeof document !== 'undefined';
}

export function isServer() {
  return typeof window === 'undefined' && typeof document === 'undefined';
}

export function isProduction() {
  const vercelEnv =
    process.env.VERCEL_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV;
  return vercelEnv === 'production';
}
